import { useContext } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { LocalWidgetRouterContext, useWidgetNavigate } from '@/core/widgets/export';
import { Permissions, useEffectivePermissions } from '@/core/permissions/export';
import styles from '@/modules/pipelines/components/deep-dive/pipeline-map-tabs.module.scss';

type PipelineMapTab = 'map' | 'assetMetrics' | 'analysis' | 'assets' | 'notifications';

const ROUTES: Record<PipelineMapTab, string> = {
  map: '',
  assetMetrics: 'asset-metrics',
  analysis: 'analysis',
  assets: 'assets',
  notifications: 'notifications',
};

const TABS: { key: PipelineMapTab; label: string; requiresPlus?: boolean }[] = [
  { key: 'map', label: 'Map', requiresPlus: true },
  { key: 'assets', label: 'Assets', requiresPlus: true },
  { key: 'assetMetrics', label: 'Asset Metrics', requiresPlus: true },
  { key: 'analysis', label: 'Analysis', requiresPlus: true },
  { key: 'notifications', label: 'Notifications' },
];

// notice/:id and history/:groupId/:id are drill-downs from the map.
function tabForPath(path = ''): PipelineMapTab {
  const [firstSegment = ''] = path.split('?')[0].split('/').filter(Boolean);
  const match = (Object.keys(ROUTES) as PipelineMapTab[]).find(t => ROUTES[t] === firstSegment);
  return match ?? 'map';
}

export default function PipelineMapTabBar() {
  const navigate = useWidgetNavigate();
  const permissions = useEffectivePermissions();
  const hasPlus = permissions.includes(Permissions.PETRO_PIPELINES_PLUS);
  const path = useContext(LocalWidgetRouterContext).path;

  const visibleTabs = TABS.filter(t => !t.requiresPlus || hasPlus);
  const pathTab = tabForPath(path);
  // Without Plus, gated tabs fall back to the notifications panel (PipelinePlusRoute).
  const active = visibleTabs.some(t => t.key === pathTab) ? pathTab : 'notifications';

  return (
    <Tabs
      justify={true}
      activeKey={active}
      onSelect={key => key && navigate(ROUTES[key as PipelineMapTab])}
      className={`mb-3 ${styles.tabBar}`}
    >
      {visibleTabs.map(t => (
        <Tab key={t.key} eventKey={t.key} title={t.label} />
      ))}
    </Tabs>
  );
}
